export function getDeviceName(device, currentCompanyId) {
  return currentCompanyId
    ? device?.name
    : device?.customName || device?.userAccess?.customDeviceName || device?.name
}
